module.exports = __webpack_public_path__ + "static/media/arrow-down.04de6fd3.svg";